import { render, staticRenderFns } from "./Pep-statement-notification-search.vue?vue&type=template&id=bec676ae&scoped=true"
import script from "./Pep-statement-notification-search.vue?vue&type=script&lang=js"
export * from "./Pep-statement-notification-search.vue?vue&type=script&lang=js"
import style0 from "./Pep-statement-notification-search.vue?vue&type=style&index=0&id=bec676ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec676ae",
  null
  
)

export default component.exports